import type CardLocation from '@alltrails/amplitude/enums/CardLocation';
import type MapLocation from '@alltrails/amplitude/enums/MapLocation';
import { PageStrings } from '@alltrails/core/constants/pageStringHelpers';
import TrailheadVectorOverlay from '@alltrails/maps/components/TrailheadVectorOverlay/TrailheadVectorOverlay';
import { useAppSelector } from '@/utils/redux';

type Props = {
  detailedCardLocation?: CardLocation;
  mapLocation?: MapLocation | string;
};

const TrailheadMapComponents = ({ detailedCardLocation = 'explore tab map view', mapLocation = PageStrings.EXPLORE_ALL_PAGE }: Props) => {
  const mapPadding = useAppSelector(state => state.explore.mapPadding);
  return <TrailheadVectorOverlay detailedCardLocation={detailedCardLocation} mapLocation={mapLocation} mapPadding={mapPadding} />;
};

export default TrailheadMapComponents;
